export default "__VITE_ASSET__CHCAj4ye__"